import React, { useRef } from 'react';
import { Input } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';

const AccessibleInput = ({
                             value,
                             onChange,
                             placeholder = '',
                             ...props
                         }) => {
    const inputRef = useRef();

    const handleClear = () => {
        onChange?.({ target: { value: '' } });
        inputRef.current?.focus();
    };

    return (
        <>
            <Input
                {...props}
                ref={inputRef}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
            />
            {value && (
                <button
                    type="button"
                    className="ch-accessible-clear-button"
                    aria-label="Clear entry"
                    tabIndex={0}
                    onClick={handleClear}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        border: 'none',
                        padding: 0,
                        marginLeft: 'var(--spacing-unit)',
                        cursor: 'pointer',
                        fontSize: 20,
                    }}
                >
                    <CloseCircleFilled aria-hidden="true" style={{fontSize: 20}}/>
                </button>
            )}
        </>
    );
};

export default AccessibleInput;
